import { colord as r } from "./index73.mjs";
const o = (t) => t.startsWith("#") ? t : r(t).toHex();
export {
  o as normalizeToHex
};
